import React, { ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.p`
  align-items: center;
  background: ${({ theme }) => theme.palette.primary.light};
  color: ${({ theme }) => theme.palette.font.light};
  display: flex;
  font-size: 14px;
  font-weight: bold;
  height: 36px;
  justify-content: center;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

type Props = {
  variant?: 'h1' | 'h2' | 'h3' | 'p'
  children: ReactNode
  className?: string
}

export default function Heading({ variant, children, className }: Props) {
  return (
    <Container className={className} as={variant}>
      {children}
    </Container>
  )
}
